import EventApi from './event-api';
import ContentApi from './content-api';
import CompanyApi from './company-api';
import ContactApi from "./contact-api";
import OfficeApi from './office-api';
import MeetingsApi from './meetings-api';
import ApiBase from "./api-base";
import MembershipsApi from './memberships-api';
import CoWorkingApi from './co-working-api';

class SeamApi extends ApiBase{
    constructor(url) {
        super(url);
    }

    handleError(error = this.defaultError) {
        throw new Error(error);
    }


    events() {
        return new EventApi(this);
    }

    content() {
        return new ContentApi(this);
    }

    companies() {
        return new CompanyApi(this);
    }

    contacts() {
        return new ContactApi(this);
    }

    offices() {
        return new OfficeApi(this);
    }

    meetings() {
        return new MeetingsApi(this);
    }

    memberships() {
        return new MembershipsApi(this);
    }

    coworking() {
        return new CoWorkingApi(this);
    }
}


export default new SeamApi('/api/connector/standard-call');
